export const initStoreById = {
  accountingToken: '',
  address: '',
  domain: '',
  email: '',
  id: '',
  legalEntityId: '',
  logo: null,
  name: '',
  phone: '',
  storeSettings: {
    categories: {},
    cdekWebhookUuid: null,
    checkoutType: null,
    currencies: [],
    defaultCurrency: 'RUB',
    defaultLanguage: 'EN',
    filterByCategory: false,
    languages: [
      {
        code: '',
        flag: '',
        flagImage: null,
        isDefault: '',
        iso: '',
        name: '',
      },
    ],
    marketplaces: [],
    media: {
      seo: {
        title: '',
        description: '',
        copyright: null,
      },
      socials: {
        vk: { icon: null, link: null, enabled: true },
        instagram: { icon: null, link: null, enabled: true },
        facebook: { icon: null, link: null, enabled: true },
        youtube: { icon: null, link: null, enabled: true },
        telegram: { icon: null, link: null, enabled: true },
        rutube: { icon: null, link: null, enabled: true },
      },
    },
    notificationEmail: '',
    notifyNewOrders: false,
    paymentProviders: [],
    shippingProviders: [],
    smtp: {
      encryption: '',
      host: '',
      logo: null,
      password: '',
      port: '',
      subject: '',
      username: '',
    },
    sortByAvailable: false,
    yandexMetrikaCounterId: null,
  },
}
